import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import RouteTracker from "@/components/RouteTracker";
import Home from "@/pages/Home";
import Packages from "@/pages/Packages";
import BecomeAPoster from "@/pages/BecomeAPoster";
import ScheduleCampaign from "@/pages/ScheduleCampaign";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function Layout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
            <WhatsAppFAB />
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <RouteTracker />
                <Routes>
                    <Route path="/" element={<Layout><Home /></Layout>} />
                    <Route path="/packages" element={<Layout><Packages /></Layout>} />
                    <Route path="/become-poster" element={<Layout><BecomeAPoster /></Layout>} />
                    <Route path="/schedule" element={<Layout><ScheduleCampaign /></Layout>} />
                    <Route path="/contact" element={<Layout><Contact /></Layout>} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
